/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';

window.Vue = Vue;

require('./bootstrap');
require('./bugsnag');
require('./datadog');

import 'leaflet/dist/leaflet.css';

import Sticky from './components/vue-sticky-directive'

Vue.use(Sticky)

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
import ReadMore from './components/vue-read-more'

// import Skeleton from 'vue-loading-skeleton';
// Vue.use(Skeleton)

import VuePluralize from '../../node_modules/vue-pluralize';

Vue.use(VuePluralize)
Vue.use(ReadMore);

import VueWaypoint from 'vue-waypoint'

// Waypoint plugin https://www.npmjs.com/package/vue-waypoint
Vue.use(VueWaypoint)

// Vue Tooltips https://hekigan.github.io/vue-directive-tooltip/
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip);

import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker' // https://mikaeledebro.gitbooks.io/vue-airbnb-style-datepicker/INSTALLATION.html

import router from './routes/profile'

const datepickerOptions = {
    colors: {
        selected: '#DB2115',
        inRange: '#EC908A',
        selectedText: '#fff',
        text: '#2A3241',
        inRangeBorder: '#DB2115',
        disabled: '#fff',
        hoveredInRange: '#EC908A'
    }
};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

// Vue Scrollactive https://github.com/eddiemf/vue-scrollactive
// park sub-nav jumping and highlighting active viewport section
var VueScrollactive = require('vue-scrollactive');
Vue.use(VueScrollactive);

// vue toast https://github.com/Maronato/vue-toastification
import Toast, {POSITION, TYPE} from "vue-toastification";

Vue.use(Toast, {
    position: POSITION.BOTTOM_RIGHT,
    toastDefaults: {
        [TYPE.DEFAULT]: {
            icon: 'toast-icon-default',
        },
        [TYPE.SUCCESS]: {
            icon: 'toast-icon-success',
        },
        [TYPE.INFO]: {
            icon: 'toast-icon-info',
        },
        [TYPE.ERROR]: {
            timeout: 10000,
            hideProgressBar: true,
            icon: 'toast-icon-warning',
        },
        [TYPE.WARNING]: {
            timeout: 10000,
            hideProgressBar: true,
            icon: 'toast-icon-warning',
        },
    },
    accessibility: {
        toastRole: "alert",
        closeButtonLabel: "close",
    },
});

/*
* Optimized https://medium.com/maatwebsite/reducing-vue-application-file-size-with-laravel-mix-e483f746d836
 */
import VueCookies from 'vue-cookies'

import {store, Photos, Theater} from "./carousel.js";
import {ObserveVisibility} from 'vue-observe-visibility';


Vue.directive('observe-visibility', ObserveVisibility)

Vue.component('site-alert-bar', () => import('./components/includes/siteAlertBar'));
Vue.component('user-search', () => import('./components/includes/userSearch'));
Vue.component('nearbycities', () => import('./components/nearbyCities'));
Vue.component('rvlifearticles', () => import('./components/rvLifeArticles'));
Vue.component('browsecities', () => import('./components/browseRegionCities'));
Vue.component('browsecounties', () => import('./components/browseRegionCounties'));
Vue.component('star', () => import('./components/includes/star'));
Vue.component('starscore', () => import('./components/includes/starScore'));
Vue.component('highrated', () => import('./components/highRatedParks'));
Vue.component('mapmarker', () => import('./components/includes/mapMarker'));
Vue.component('filters', () => import('./components/includes/filters'));
Vue.component('parks', () => import('./components/parks'));
Vue.component('skeleton-loader', () => import('./components/skeletonLoader'));

//base components - eventually auto load if enough
Vue.component('textarea-counter', () => import('./components/base/textareaCounter'));
Vue.component('svg-icon', () => import('./components/base/svgIcon'));
Vue.component('avatar', () => import('./components/base/avatar'));
Vue.component('modal', () => import('./components/base/modal'));
Vue.component('panel-collapse', () => import('./components/base/panelCollapse'));
//

Vue.component('nearby-states', () => import('./components/nearbyStates'));
Vue.component('popular-cities', () => import('./components/popularCities'));
Vue.component('breadcrumbs', () => import('./components/includes/breadcrumbs'));
Vue.component('recent-reviews', () => import('./components/recentReviews'));
Vue.component('recent-questions', () => import('./components/recentQuestions'));
Vue.component('tips', () => import('./components/tips'));
Vue.component('featured-contributors', () => import('./components/featuredContributors'));
Vue.component('recent-photos', () => import('./components/recentPhotos'));
Vue.component('nearby-campgrounds', () => import('./components/nearbyCampgrounds'));
Vue.component('stretch-spinner', () => import('./components/spinners/Stretch'));
Vue.component('texture-spinner', () => import('./components/spinners/Texture'));
Vue.component('circle-spinner', () => import('./components/spinners/Circle2'));
Vue.component('add-favorites', () => import('./components/includes/addToFavorites'));
Vue.component('favorites-modal', () => import('./components/includes/modals/favoritesModal'));
Vue.component('guest-roadblock-modal', () => import('./components/includes/modals/guestRoadblock'));
Vue.component('update-notes-modal', () => import('./components/includes/modals/updateNotes'));
Vue.component('ask-question', () => import('./components/includes/modals/askQuestion'));
Vue.component('ask-question-button', () => import('./components/includes/buttons/askQuestionButton'));
Vue.component('answer-question', () => import('./components/includes/modals/answerQuestion'));
Vue.component('featured-parks', () => import('./components/featuredParks'));
Vue.component('nearby-featured-parks', () => import('./components/nearbyFeaturedCampgrounds'));
Vue.component('swiper-featured-campgrounds', () => import('./components/swiperFeaturedCampgrounds'));
Vue.component('swiper-featured-contributors', () => import('./components/swiperFeaturedContributors'));
Vue.component('new-fav-list', () => import('./components/includes/newFavList'));
Vue.component('park-discussion', () => import('./components/includes/modals/parkDiscussion'));
Vue.component('park-notes', () => import('./components/includes/modals/parkNotes'));
Vue.component('state-list', () => import('./components/includes/stateList'));
Vue.component('usa-map', () => import('./components/includes/maps/usaMap'));
Vue.component('mx-map', () => import('./components/includes/maps/mxMap'));
Vue.component('ca-map', () => import('./components/includes/maps/caMap'));
Vue.component('park-head', () => import('./components/parkHead'));
Vue.component('park-subnav', () => import('./components/parkSubNav'));
Vue.component('park-details', () => import('./components/parkDetails'));
Vue.component('price-rate', () => import('./components/includes/priceRate'));
Vue.component('features-amenities', () => import('./components/featuresAndAmenities'));
Vue.component('top-question', () => import('./components/topQuestion'));
Vue.component('top-tip', () => import('./components/topTip'));
Vue.component('review-ratings-overview', () => import('./components/reviewAndRatingsOverview'));
Vue.component('park-questions', () => import('./components/parkQuestions'));
Vue.component('park-tips', () => import('./components/parkTips'));
// Vue.component('weather-widget', () => import('./components/includes/weatherWidget'));
Vue.component('featured-header', () => import('./components/includes/featuredHeader'));
Vue.component('all-reviews-feed', () => import('./components/allReviewsFeed'));
Vue.component('all-photos-feed', () => import('./components/allPhotosFeed'));
Vue.component('photos-filter', () => import('./components/includes/photosFilter'));
Vue.component('park-feed', () => import('./components/parkFeed'));
Vue.component('park-feed-widgets', () => import('./components/parkFeedWidgets'));
Vue.component('park-review-bit', () => import('./components/parkReview'));
Vue.component('park-edit', () => import('./components/parkEdit'));
Vue.component('single-review', () => import('./components/singleReview'));
Vue.component('single-photo', () => import('./components/singlePhoto'));
Vue.component('photo-panel', () => import('./components/includes/photoPanel'));
Vue.component('arrival-activity', () => import('./components/includes/arrivalActivity'));
Vue.component('photo-panel-photo', () => import('./components/includes/photoPanelPhoto'));
Vue.component('photoTagSelect', () => import('./components/includes/photoTagSelect'));
Vue.component('speed-test-result', () => import('./components/includes/speedTestResult'));
Vue.component('activity-header', () => import('./components/includes/activityHeader'));
Vue.component('activity-jump', () => import('./components/includes/activityJump'));
Vue.component('report-concern', () => import('./components/includes/modals/reportConcern'));
Vue.component('not-recommended', () => import('./components/includes/modals/notRecommended'));
Vue.component('delete-review', () => import('./components/includes/modals/deleteReview'));
Vue.component('delete-photo', () => import('./components/includes/modals/deletePhoto'));
Vue.component('change-park', () => import('./components/includes/modals/changePark'));
Vue.component('claim-park', () => import('./components/includes/modals/claimPark'));
Vue.component('speed-test-page', () => import('./components/speed-test/SpeedTestPage'));
Vue.component('speed-test-dropdown-item', () => import('./components/speed-test/DropDownItem'));
Vue.component('speed-test-modal', () => import('./components/speed-test/Modal'));
Vue.component('profile-head', () => import('./components/profileHead'));
Vue.component('reviews-breakdown', () => import('./components/reviewsBreakdown'));
Vue.component('reviews-filter', () => import('./components/includes/reviewsFilter'));
Vue.component('request-revision', () => import('./components/includes/modals/requestRevision'));
Vue.component('user-activity', () => import('./components/UserActivity'));
Vue.component('avatar-edit', () => import('./components/avatarEdit'));
Vue.component('cover-pic-edit', () => import('./components/coverPicEdit'));
Vue.component('cover-pic', () => import('./components/includes/coverPic'));
Vue.component('country-state-city-form', () => import('./components/includes/countryStateCityForm'));
Vue.component('favorites', () => import('./components/favorites'));
Vue.component('favorites-profile', () => import('./components/favoritesProfile'));
Vue.component('favorite-list', () => import('./components/favoriteList'));
Vue.component('helpful-voting', () => import('./components/includes/helpfulVoting'));
Vue.component('add-park', () => import('./components/addPark'));
Vue.component('ad-container', () => import('./components/ads/adContainer'));
Vue.component('ad-300-250-Top-Right', () => import('./components/ads/300x250_Top_Right'));
Vue.component('ad-300-250-Middle-Right', () => import('./components/ads/300x250_Middle_Right'));
Vue.component('ad-300-250-Bottom-Right', () => import('./components/ads/300x250_Bottom_Right'));
Vue.component('ad-300-250-Top-Left', () => import('./components/ads/300x250_Top_Left'));
Vue.component('ad-native-cgr', () => import('./components/ads/native_CGR'));
Vue.component('question', () => import('./components/question'));
Vue.component('answer', () => import('./components/answer'));
Vue.component('register', () => import('./components/register'));
Vue.component('after-registration-modal', () => import('./components/includes/modals/afterRegistrationModal'));
Vue.component('connect-accounts', () => import('./components/connectAccounts'));
Vue.component('answer-question-form', () => import('./components/includes/answerQuestionForm'));
Vue.component('contributor', () => import('./components/includes/contributor'));
Vue.component('contributors-by-region-list', () => import('./components/contributorsByRegionList'));
Vue.component('contributors-head', () => import('./components/includes/contributorsHead'));
Vue.component('admin-tools', () => import('./components/includes/adminTools'));
Vue.component('admin-user-settings', () => import('./components/AdminUserSettings'));
Vue.component('city-list', () => import('./components/includes/cityList'));
Vue.component('photo-modal', () => import('./components/includes/modals/photoModal'));
Vue.component('theater-content', () => import('./components/includes/theaterContent'));
Vue.component('users-who-reviews', () => import('./components/includes/usersWhoReviewed'));
Vue.component('park-review-ai-summary', () => import('./components/includes/ParkReviewAiSummary'));
Vue.component('search-box', () => import('./components/includes/searchBox'));
Vue.component('toggle-header', () => import('./components/includes/toggleHeader'));
Vue.component('user-menu', () => import('./components/includes/userMenu'));

Vue.component('covid-date-updated', () => import('./components/includes/covidDateUpdated'));

Vue.component('country-state-type', () => import('./components/includes/MassSearchByState'));

Vue.component('temp-alert', () => import('./components/includes/tempAlert'));

Vue.component('notes', () => import('./components/includes/notes'));

//Add Reviews
Vue.component('add-review', () => import('./components/addReview'));
Vue.component('step1', () => import('./components/includes/add-review/step1'));
Vue.component('step2', () => import('./components/includes/add-review/step2'));
Vue.component('step3', () => import('./components/includes/add-review/step3'));
Vue.component('step4', () => import('./components/includes/add-review/step4'));

Vue.component('moderate-review', () => import('./components/includes/moderateReview'));
Vue.component('moderate-photo', () => import('./components/includes/moderatePhoto'));

Vue.component('park-map', () => import('./components/map/parkMap'));
Vue.component('featured-park-card', () => import('./components/parks/featuredParkCard.vue'));
Vue.component('featured-park-list', () => import('./components/parks/featuredParkList.vue'));
Vue.component('marker-map', () => import('./components/map/markerMap'));
Vue.component('cities-or-counties', () => import('./components/citiesOrCounties'));
Vue.component('cities-or-counties-mobile', () => import('./components/citiesOrCountiesMobile'));
Vue.component('city-header', () => import('./components/includes/cityHeader'));
Vue.component('state-header', () => import('./components/includes/stateHeader'));
Vue.component('guage-spinner', () => import('./components/spinners/Gauge'));
Vue.component('photo-uploader', () => import('./components/photoUploader'));
Vue.component('upload-photo-modal', () => import('./components/includes/modals/uploadPhotoModal'));
Vue.component('map-parks-actions', () => import('./components/includes/mapParksActions'));
Vue.component('upload-photo-page', () => import('./components/uploadPhotoPage'));
Vue.component('revision-history', () => import('./components/includes/modals/revisionHistory'))

Vue.component('save-button', () => import('./components/includes/buttons/saveButton'));
Vue.component('message', () => import('./components/includes/message'));
Vue.component('smart-banner', () => import('./components/SmartBanner'));
Vue.component('footer-content', () => import('./components/includes/footerContent'));
Vue.component('favorite-button', () => import('./components/includes/buttons/favoriteButton'));

window.ParkMapEvent = new class {
    constructor() {
        this.vue = new Vue();
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }
};

window.dev = new class {
    constructor() {
        this.enabled = window.envObj.MIX_LOGGING_ENABLED == 'true';
    }

    log(output) {
        if (this.enabled) {
            console.log(output);
        }
    }
}

/**
 * A global window object that handles socket connection
 * Currently used for review moderation
 */
window.socket = new class {
    constructor() {
        //this boolean is used to send connection request once per window instance
        this.enabled = false;
        //vue object to emit events
        this.vue = new Vue();

        if (Number(window.envObj.MIX_DISABLE_SOCKET) === 1) {
            //turn socket off for current instance
            this.disabled = true;
            console.log("SOCKET is disabled!");
        }
    }

    //setup socket io connection and listeners
    setupSocket() {
        //check if socket is disabled
        if (this.disabled) {
            return;
        }

        //one connection per app instance
        if (this.enabled) {
            dev.log("SOCKET: already enabled");
            return;
        }
        this.enabled = true;

        //must be authenticated and an admin
        if (dataStore.user === null) {
            dev.log("SOCKET: Unauthenticated");
            return;
        }
        if (!dataStore.user.admin) {
            dev.log("SOCKET: Not an admin");
            return;
        }

        let socket = io(window.envObj.MIX_BROADCASTING_URL + '/admin?id=' + dataStore.user.id);

        //get the reviews locked prior the connection
        this.getLockedReviews();

        socket.on('connect', () => {
            console.log("SOCKET: sending connection request...");
        });
        socket.on('message', function (data) {
            console.log(data);
        });

        socket.on('admin-channel:App\\Events\\LockReviewModeration', function (data) {
            dev.log(data);
            if (data.locked) {
                //a review was locked by another admin
                if (data.user !== dataStore.user.id) {
                    this.fire('lock-review', data);
                }
            } else {
                //a review was unlocked by another admin
                if (data.review) {
                    this.fire('unlock-review', data);
                }
            }
        }.bind(this));
    }

    //get all locked reviews using api request
    getLockedReviews() {
        axios.get(globalApiUrl + '/broadcast/locked-reviews',
            {
                headers: {
                    accept: 'application/x.rvparkreviews.v3+json'
                },
                withCredentials: true
            })
            .then(response => {
                if (response.data && response.data.length > 0) {
                    this.fire('locked-reviews', response.data);
                }
            })
            .catch(e => {
                console.log("Error: couldn't fetch locked reviews");
                console.log(e);
            })
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }
}

Vue.mixin({
    data: function () {
        return {
            lat: userLat,
            lon: userLon,
            ratingIcons: ratingIcons,
            dataStore: dataStore,
            apiUrl: globalApiUrl,
            photoUrl: bucketUrl,
            currentSort: 'time',
            getCurrentPosition: function (options) {
                return new Promise(function (resolve, reject) {
                    navigator.geolocation.getCurrentPosition(resolve, reject, options);
                });
            },
            tipCharLimit: 300,
            country: sessionCountry,
            sortObjects: ['reviews', 'tips', 'photos', 'questions'],
            appName: appName,
            appNameCgr: appNameCgr,
            adIds: window.envObj.ADS_WRAPPER_IDS,
            visibleAds: [],
        }
    },
    filters:
        {
            truncateText: function (text, length, clamp, f) {
                clamp = clamp || '...';
                var node = document.createElement('div');
                node.innerHTML = text;
                var content = node.textContent;
                return content.length > length ? content.slice(0, length) + clamp : content;
            },

            stripHtml: function (value) {
                var div = document.createElement("div");
                div.innerHTML = value;
                var text = div.textContent || div.innerText || "";
                return text;
            },

            formatText: function (value) {
                if (!value) return ''

                value = value.toString()

                var div = document.createElement("div");

                div.innerHTML = value;

                value = div.textContent || div.innerText || "";

                var ret = value.split('. ').map(function (el) {
                    el = el.trim();
                    return el.substr(0, 1).toUpperCase() + el.substr(1);
                }).join('. ')
                    .split('? ').map(function (el) {
                        el = el.trim();
                        return el.substr(0, 1).toUpperCase() + el.substr(1);
                    }).join('? ')
                    .split('! ').map(function (el) {
                        el = el.trim();
                        return el.substr(0, 1).toUpperCase() + el.substr(1);
                    }).join('! ')
                    .split("\n\n").map(function (el) {
                        el = el.trim();
                        return el.substr(0, 1).toUpperCase() + el.substr(1);
                    }).join("\n\n");

                return ret.replace(/(\r\n|\r|\n){2,}/g, '$1\n')
                    .replace(/( ){2,}/g, '$1')
                    .replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '') // strip anything other than letters, numeric characters, punctuations, whitespaces or line-feeds (new line)
                    .replace(/(?:\r\n|\r|\n)/g, '<br>'); // replace line-feeds with <br> tag
            },
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }

        },
    directives:
        {
            phoneFormat: function (el) {
                el.value = el.value.replace(/[^0-9]/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            }
        },
    mounted() {
        this.$on('send_user', (user) => {
            this.dataStore.user = user;
        });
    },

    methods:
        {
            visibilityChanged(isVisible, entry, f) {
                this.$root.$emit('visible_' + f, isVisible);
            },
            cookies() {
                return $cookies;
            },
            CookieSet(key, val, time = false) {
                if (!time) {
                    $cookies.set(key, val)
                } else {
                    $cookies.set(key, val, time)
                }
            },

            formatPhone(phone) {
                let x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d*)/);
                return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },

            formatBits: function (bits, decimals = 2) {
                if (bits === 0) return '0<small>B</small>';

                const k = 1000;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
                const i = Math.floor(Math.log(bits) / Math.log(k));

                return `${parseFloat((bits / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
            },

            isOwner(park, userId) {
                var uid = parseInt(userId);

                var oid = 0;

                var index = park.owner.length;

                while (index--) {
                    oid = parseInt(park.owner[index])

                    if (uid == oid)
                        return true;
                }

                return false;
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body;

                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
            md5: function (string) {
                string = string + new Date().getHours() + storageKey; // Let's update the cache every hour to be safe
                var MD5 = function (d) {
                    var result = M(V(Y(X(d), 8 * d.length)));
                    return result.toLowerCase()
                };

                function M(d) {
                    for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
                    return f
                }

                function X(d) {
                    for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0;
                    for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
                    return _
                }

                function V(d) {
                    for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
                    return _
                }

                function Y(d, _) {
                    d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
                    for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
                        var h = m, t = f, g = r, e = i;
                        f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e)
                    }
                    return Array(m, f, r, i)
                }

                function md5_cmn(d, _, m, f, r, i) {
                    return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m)
                }

                function md5_ff(d, _, m, f, r, i, n) {
                    return md5_cmn(_ & m | ~_ & f, d, _, r, i, n)
                }

                function md5_gg(d, _, m, f, r, i, n) {
                    return md5_cmn(_ & f | m & ~f, d, _, r, i, n)
                }

                function md5_hh(d, _, m, f, r, i, n) {
                    return md5_cmn(_ ^ m ^ f, d, _, r, i, n)
                }

                function md5_ii(d, _, m, f, r, i, n) {
                    return md5_cmn(m ^ (_ | ~f), d, _, r, i, n)
                }

                function safe_add(d, _) {
                    var m = (65535 & d) + (65535 & _);
                    return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m
                }

                function bit_rol(d, _) {
                    return d << _ | d >>> 32 - _
                }

                return MD5(string);
            },
            ucwords: function (str) {
                return str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
            },
            doRatingNumber: function (rtg, fixed, five) {
                if (five)
                    return parseFloat(rtg / 2).toFixed(parseInt(fixed))

                /*
                if (fixed == 0)
                {
                    if((rtg % 1) >= 0.45)
                    {
                        rtg = Math.ceil(rtg);
                    }
                    else {
                        rtg = Math.floor(rtg);
                    }
                }
                */
                return parseFloat(rtg).toFixed(parseInt(fixed))
            },
            getRoute: function (routeName, params = {}) {
                return route(routeName, params);
            },
            addInterEvent: function (name, id) {
                axios.get(globalApiUrl + '/event/' + name + '/' + id,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true,
                    })
                    .then(response => {

                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },
            addInterEvents: function addInterEvents(formdata) {
                var _this = this;

                axios.post(globalApiUrl + '/event', formdata, {
                    headers: {
                        accept: 'application/x.rvparkreviews.v3+json'
                    },
                    withCredentials: true
                }).then(function (response) {
                }).catch(function (e) {
                    _this.loading = false;
                    console.log("An error occurred. " + e + " / Error status: " + e.response);
                });
            },
            setCountry: function (country) {

                this.countryIcon = country;

                if (sessionCountry === country)
                    return;

                axios.get('/misc/set-country/' + country,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        }
                    })
                    .then(response => {
                        this.mapStates = [];
                        this.country = country;
                        this.countryIcon = country;
                        sessionCountry = country;
                        this.$root.$emit('new_country', sessionCountry);
                        //console.log(response.data);
                        this.mapStates = response.data;
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            direction: function (endpoint, startpoint) {

                var x1 = endpoint.lat;
                var y1 = endpoint.lon;
                var x2 = startpoint.lat;
                var y2 = startpoint.lon;

                var radians = getAtan2((y1 - y2), (x1 - x2));

                function getAtan2(y, x) {
                    return Math.atan2(y, x);
                };

                var compassReading = radians * (180 / Math.PI);

                var coordNames = ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "N"];
                var coordIndex = Math.round(compassReading / 45);
                if (coordIndex < 0) {
                    coordIndex = coordIndex + 8
                }

                return coordNames[coordIndex];
            },

            //For substringing text
            substr: function (str, len) {
                return str.length > len ? str.substring(0, len) + '...' : str;
            },
            //Load Filters
            loadFilters: function () {
                this.loading = true;
                var tpath = globalApiUrl + '/filters?v=2';
                if (localStorage[this.md5(tpath)]) {
                    this.filters = [];
                    this.loading = false;
                    this.filters = JSON.parse(localStorage[this.md5(tpath)]);
                } else {
                    axios.get(tpath,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            }
                        })
                        .then(response => {
                            this.filters = [];
                            this.loading = false;
                            this.filters = response.data;
                            localStorage[this.md5(tpath)] = JSON.stringify(response.data);
                        })
                        .catch(e => {
                            this.loading = false;
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            //Park in List
            parkInList: function (parkid, list) {
                if (undefined !== list && list.length) {
                    var length = list.length;

                    for (var i = 0; i < length; i++) {
                        if (list[i]['object_id'] == parkid && list[i]['type'] == 'park') {
                            return true;
                        }
                    }
                }
                return false;
            },

            getPhotoTags() {
                axios.get(globalApiUrl + '/photo-tags', {
                    headers: {
                        accept: 'application/x.rvparkreviews.v3+json'
                    },
                })
                    .then(response => this.$root.$emit('tags_loaded', response.data))
                    .catch(error => {
                        console.log(error.response.data);
                    });
            },

            deleteDraftReview(reviewId, redir) {
                this.loading = true;

                axios.get(globalApiUrl + '/delete-draft/' + reviewId,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {

                        var d = response.data;

                        if (d.error !== undefined) {
                            this.loading = false;

                            Vue.$toast.error(d.message)
                        }

                        window.location = redir;

                    })
                    .catch(e => {
                        this.loading = false;
                        Vue.$toast.error("An error occurred. " + e + " / Error status: " + e.response);
                    })


            },

            clearParkCache() {
                axios.get(globalApiUrl + '/admin/clear-cache/' + this.$props.park.id,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        Vue.$toast.success('Cache Cleared');
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            // Load more activity
            loadMoreActivity: function (user, count, queryArgs) {
                var args = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                this.loading = true;

                axios.get(globalApiUrl + '/activity/' + user + '?' + 'page=' + count + args,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.activities = [];
                        this.loading = false;
                        this.activities = response.data;
                        var tThis = this;
                        response.data.data.forEach(function (i) {
                            tThis.listdata.push(i);
                        });

                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            loadMoreCities: function (cityId) {
                axios.get(globalApiUrl + '/cities-nearby/' + cityId,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.cities = [];
                        this.loading = false;
                        this.cities = response.data;
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            loadCities: function (regionId, notImported = true, county = null) {

                var url = globalApiUrl + '/cities/' + regionId;

                if (county !== null) {
                    url += '/' + county.id
                }

                url += '?notImported=' + notImported;


                axios.get(url,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.cities = [];
                        this.loading = false;
                        this.cities = response.data;
                        //to indicate citiesOrCounties that cities have been loaded
                        ParkMapEvent.fire('city-loaded');
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            loadCounties: function (regionId, resource = false
            ) {
                var url = globalApiUrl + '/counties/' + regionId;

                if (resource)
                    url += '/true';

                axios.get(url,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.counties = [];
                        this.loading = false;
                        this.counties = response.data;
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },


            // Load more reviews
            loadMoreStates: function (count, queryArgs) {
                var args = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                this.loading = true;

                var tpath = globalApiUrl + '/nearby-states?page=' + count + args + '&lat=' + this.lat + '&lon=' + this.lon;
                //localStorage.removeItem(this.md5(tpath));
                if (localStorage[this.md5(tpath)]) {
                    this.states = [];
                    this.loading = false;
                    this.states = JSON.parse(localStorage[this.md5(tpath)]);
                } else {
                    axios.get(tpath,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            }
                        })
                        .then(response => {
                            this.states = [];
                            this.loading = false;
                            this.states = response.data;
                            try {
                                localStorage[this.md5(tpath)] = JSON.stringify(response.data);
                            } catch (e) {
                                localStorage.clear();
                                console.log(e);
                            }

                        })
                        .catch(e => {
                            this.loading = false;
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            // Load favorite Lists
            loadFavoriteLists: function (userid) {
                this.loading = true;

                axios.get(globalApiUrl + '/favorite-lists/show/' + userid + '?lite=true',
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.favoriteLists = [];
                        this.loading = false;
                        this.favoriteLists = response.data;
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            isItoy: function () {
                return navigator.userAgent.match(/(iPod|iPhone|iPad)/)
            },

            // Load more reviews
            loadMoreReviews: function (count, queryArgs, emit = false) {
                let args = '';
                let sortingBy = ''

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');

                        if (el == 'sortBy')
                            sortingBy = queryArgs[el];
                    }
                );

                this.loading = true;

                var tempThis = this;

                if (!browserLocation && sortingBy == 'location') {
                    this.getCurrentPosition()
                        .then((location) => {
                            tempThis.lat = location.coords.latitude;
                            tempThis.lon = location.coords.longitude;
                            //overwrite initial values at the footer; used later to avoid repeat loc request on same page
                            userLat = location.coords.latitude;
                            userLon = location.coords.longitude;
                            browserLocation = true;

                            action(count, queryArgs, tempThis);
                        })
                        .catch((err) => {
                            action(count, queryArgs, tempThis);
                        });
                } else {
                    //if has browser location output and sort by nearest request
                    if (browserLocation && sortingBy == 'location') {
                        tempThis.lat = userLat;
                        tempThis.lon = userLon;
                    }
                    action(count, queryArgs, tempThis);
                }

                function action(count, queryArgs, tthis) {

                    var url = globalApiUrl + '/recent-reviews?page=' + count + args;

                    if (queryArgs.sortBy == 'location' && tthis.lat && tthis.lon) {
                        url += '&lat=' + tthis.lat + '&lon=' + tthis.lon;
                    }

                    axios.get(url,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            },
                            withCredentials: true
                        })
                        .then(response => {
                            if (emit) {
                                tthis.$root.$emit('reviews-loaded', response.data);
                            } else {
                                tthis.reviews = [];
                                tthis.loading = false;
                                tthis.reviews = response.data;
                                tthis.$root.$emit('reviews_loaded');
                            }
                        })
                        .catch(e => {
                            tthis.loading = false;
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            loadMoreTips: function (count, queryArgs) {
                var args = '';
                var sortingBy = ''

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                        if (el == 'sortBy')
                            sortingBy = queryArgs[el];
                    }
                );

                this.loading = true;

                var tempThis = this;

                if (!browserLocation && (sortingBy == 'location' || sortingBy == 'location_time')) {
                    this.getCurrentPosition().then((location) => {
                        tempThis.lat = location.coords.latitude;
                        tempThis.lon = location.coords.longitude;
                        userLat = location.coords.latitude;
                        userLon = location.coords.longitude;
                        browserLocation = true;

                        action(count, queryArgs, tempThis);
                    })
                        .catch((err) => {
                            action(count, queryArgs, tempThis);
                        });
                } else {
                    if (browserLocation && sortingBy == 'location') {
                        tempThis.lat = userLat;
                        tempThis.lon = userLon;
                    }
                    action(count, queryArgs, tempThis);
                }

                function action(count, queryArgs, tthis) {

                    axios.get(globalApiUrl + '/recent-reviews?limit=3&page=' + count + args + '&lat=' + tthis.lat + '&lon=' + tthis.lon,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            }
                        })
                        .then(response => {
                            tthis.tips = [];
                            tthis.loading = false;
                            tthis.tips = response.data;
                            tthis.$root.$emit('tips_loaded');
                        })
                        .catch(e => {
                            tthis.loading = false;
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            loadMoreFeaturedUsers: function (count, queryArgs) {
                var args = '';

                var endpoint = 'featured-users';

                Object.keys(queryArgs).forEach(function (el) {
                        if (el == 'regionId' && queryArgs[el] != '')
                            endpoint = 'featured-users-region';

                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                this.loading = true;

                axios.get(globalApiUrl + '/' + endpoint + '?page=' + count + args,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        }
                    })
                    .then(response => {
                        this.contributors = [];
                        this.loading = false;
                        this.contributors = response.data
                    })
                    .catch(e => {
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            // Load more  parks
            loadMoreParks: function (count, queryArgs, filters, negFilters) {
                var args = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                var bodyFormData = new FormData();

                bodyFormData.set('filters', JSON.stringify(filters));

                bodyFormData.set('negFilters', JSON.stringify(negFilters));

                this.loading = true;

                axios.post(globalApiUrl + '/parks?page=' + count + args, bodyFormData,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(response => {
                        this.campgrounds = [];
                        this.loading = false;
                        this.campgrounds = response.data
                        this.$root.$emit('do_sort');
                    })
                    .catch(e => {
                        this.loading = false;
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            // Load more nearby parks
            loadMoreNearbyParks: function (count, queryArgs, isParks = false, lat = false, lon = false) {
                var args = '';

                var cache = false;

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                if (isParks) {
                    this.parks = [];
                    this.pageparks = [];
                }

                this.loading = true;

                if (!lat) {
                    cache = true;
                    lat = userLat;
                    lon = userLon;
                }

                var tpath = globalApiUrl + '/parks/parks-nearby/' + lat + '/' + lon + '?page=' + count + args;
                if (!isParks && localStorage[this.md5(tpath)] && cache) {
                    this.campgrounds = [];

                    this.campgrounds = JSON.parse(localStorage[this.md5(tpath)]);

                    this.$root.$emit('do_sort');
                    this.loading = false;
                } else {

                    axios.get(tpath,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            },
                            withCredentials: true
                        })
                        .then(response => {
                            if (isParks) {
                                this.parks = [];
                                this.$parent.origParks = [];
                                this.pageparks = [];
                                this.campgrounds = [];
                                this.parks = response.data.data;
                                this.$parent.allparks = response.data.data;
                                this.$parent.start = 0;
                                this.$parent.end = this.$parent.increments - 1;
                                this.$parent.reload(this.$parent.filters, this.$parent.negFilters);
                                this.$root.$emit('do_sort');
                                this.$root.$emit('load_parks', response.data.data);
                                this.loading = false;

                            } else {
                                this.campgrounds = [];
                                this.campgrounds = response.data;
                                this.$root.$emit('do_sort');
                                this.loading = false;
                                if (cache)
                                    localStorage[this.md5(tpath)] = JSON.stringify(response.data);
                            }
                        })
                        .catch(e => {
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            // Load more nearby questions
            loadMoreQuestions: function (count, queryArgs) {
                var args = '';
                var sortingBy = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                        if (el == 'sortBy')
                            sortingBy = queryArgs[el];
                    }
                );

                this.loading = true;

                var tempThis = this;

                if (!browserLocation && sortingBy == 'location') {
                    this.getCurrentPosition().then((location) => {
                        tempThis.lat = location.coords.latitude;
                        tempThis.lon = location.coords.longitude;
                        userLat = location.coords.latitude;
                        userLon = location.coords.longitude;
                        browserLocation = true;

                        action(count, queryArgs, tempThis);
                    })
                        .catch((err) => {
                            action(count, queryArgs, tempThis);
                        });
                } else {
                    if (browserLocation && sortingBy == 'location') {
                        tempThis.lat = userLat;
                        tempThis.lon = userLon;
                    }
                    action(count, queryArgs, tempThis);
                }

                function action(count, queryArgs, tthis) {

                    var url = globalApiUrl + '/recent-questions' + '?page=' + count + args;

                    if (queryArgs.sortBy == 'location')
                        url += '&lat=' + tthis.lat + '&lon=' + tthis.lon;

                    axios.get(url,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            }
                        })
                        .then(response => {
                            tthis.questions = [];
                            tthis.loading = false;
                            tthis.questions = response.data

                            tthis.$root.$emit('questions_loaded');

                        })
                        .catch(e => {
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })

                }
            },

            // Load more nearby photos
            loadMorePhotos: function (count, queryArgs) {
                var args = '';
                var sortingBy = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');

                        if (el == 'sortBy')
                            sortingBy = queryArgs[el];
                    }
                );

                this.loading = true;

                var tempThis = this;

                if (!browserLocation && sortingBy == 'location') {
                    this.getCurrentPosition().then((location) => {
                        tempThis.lat = location.coords.latitude;
                        tempThis.lon = location.coords.longitude;

                        userLat = location.coords.latitude;
                        userLon = location.coords.longitude;
                        browserLocation = true;
                        action(count, queryArgs, tempThis);
                    })
                        .catch((err) => {
                            action(count, queryArgs, tempThis);
                        });
                } else {
                    if (browserLocation && sortingBy == 'location') {
                        tempThis.lat = userLat;
                        tempThis.lon = userLon;
                    }
                    action(count, queryArgs, tempThis);
                }

                function action(count, queryArgs, tthis) {

                    axios.get(globalApiUrl + '/recent-photos' + '?page=' + count + args + '&lat=' + tthis.lat + '&lon=' + tthis.lon,
                        {
                            headers: {
                                accept: 'application/x.rvparkreviews.v3+json'
                            }
                        })
                        .then(response => {
                            tthis.photos = [];
                            tthis.loading = false;
                            tthis.photos = response.data
                            tthis.$root.$emit('photos_loaded');
                        })
                        .catch(e => {
                            console.log("An error occurred. " + e + " / Error status: " + e.response)
                        })
                }
            },

            loadPhotosPos: function (count, queryArgs) {
                var args = '';

                Object.keys(queryArgs).forEach(function (el) {
                        args += '&' + el + '=' + (queryArgs[el] ? queryArgs[el] : '');
                    }
                );

                this.loading = true;

                axios.get(globalApiUrl + '/recent-photos' + '?page=' + count + args + '&lat=' + this.lat + '&lon=' + this.lon,
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        }
                    })
                    .then(response => {
                        this.position = parseInt(response.data) + 1;
                        this.loading = false;
                    })
                    .catch(e => {
                        console.log("An error occurred. " + e + " / Error status: " + e.response)
                    })
            },

            // Generate stars for ratings (max rating 5)
            stars: function (rating) {
                var full = Math.floor(rating);
                var half = (Math.ceil(rating) - full);
                var blank = (5 - (full + half));
                var fulls = Array();
                var halves = Array();
                var blanks = Array();
                var i;

                for (i = 0; i < full; i++) {
                    fulls.push(i);
                }

                for (i = 0; i < half; i++) {
                    halves.push(i);
                }

                for (i = 0; i < blank; i++) {
                    blanks.push(i);
                }

                return {fullRating: fulls, halfRating: halves, emptyRating: blanks,};
            },

            alert: function (val) {
                alert(val);
            },

            updateOrder: function (val) {
                if (this.currentSort != val) {
                    this.onOrderChange(val);
                    this.currentSort = val;
                }
            },

            updateAll: function (val) {
                return;

                $(".sortby").val(val)

                $('.sortby').trigger('click');

            },

            //  Get the distance between two points
            getDistance: function (lat1, lon1, lat2, lon2) {
                //alert(lat1 + ' ' + lon1+ ' ' + lat2+ ' ' + lon2)
                var radlat1 = Math.PI * lat1 / 180
                var radlat2 = Math.PI * lat2 / 180
                var radlon1 = Math.PI * lon1 / 180
                var radlon2 = Math.PI * lon2 / 180
                var theta = lon1 - lon2
                var radtheta = Math.PI * theta / 180
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                dist = Math.acos(dist)
                dist = dist * 180 / Math.PI
                dist = dist * 60 * 1.1515
                dist = dist * 0.8684
                return dist
            },

            //  SortBy reviews by distance
            sortByDistance: function (lat, lon) {
                //SortBy the sort objects by distance property
                for (var i = 0; i < this.sortObjects.length; i++) {
                    if (this[this.sortObjects[i]] !== undefined) {
                        for (x = 0; x < this[this.sortObjects[i]].length; x++) {
                            this[this.sortObjects[i]][x]["distance"] = this.getDistance(lat, lon, this[this.sortObjects[i]][x]["lat"], this[this.sortObjects[i]][x]["lon"]);
                        }

                        this[this.sortObjects[i]].sort(function (a, b) {
                            return a.distance - b.distance;
                        });
                    }
                }
                this.$forceUpdate();

            },
            //  SortBy reviews by date
            sortByDate: function () {
                //SortBy the sort objects by time
                for (var i = 0; i < this.sortObjects.length; i++) {
                    if (this[this.sortObjects[i]] !== undefined) {
                        this[this.sortObjects[i]].sort(function (a, b) {
                            return a.time - b.time;
                        });
                    }
                }

                this.$forceUpdate();

            },
            sortByField: function (field, reverse, primer) {
                var key = primer ?
                    function (x) {
                        return primer(x[field])
                    } :
                    function (x) {
                        if (field == 'name') {
                            return x[field].replace(/[^a-zA-Z0-9 ]/g, "");
                        } else {
                            return x[field]
                        }
                    };

                reverse = !reverse ? 1 : -1;

                return function (a, b) {
                    return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
                }
            },
            shuffle: function (a) {
                var j, x, i;
                for (i = a.length - 1; i > 0; i--) {
                    j = Math.floor(Math.random() * (i + 1));
                    x = a[i];
                    a[i] = a[j];
                    a[j] = x;
                }
                return a;
            },
            // On change of the select, change sort order
            onOrderChange: function (val) {
                if (val == 'time') {
                    return this.sortByDate();
                } else {
                    return this.sortByDistance(this.lat, this.lon);
                }
            },

            userAgent: function () {
                return navigator.userAgent;
            },

            updateTipLimit: function () {
                if (this.tipCharLimit != 300) {
                    this.tipCharLimit = 300;
                } else {
                    this.tipCharLimit = 10000000;
                }
            },

            /* Load internet carriers used in speed test */
            loadCarriers() {
                axios.get(globalApiUrl + '/carriers',
                    {
                        headers: {
                            accept: 'application/x.rvparkreviews.v3+json'
                        },
                        withCredentials: true
                    })
                    .then(({data}) => {
                        this.carriers = data
                    })
                    .catch(e => {
                        console.log(e);
                    });
            },

            deleteCheckinActivityData(checkinId){
                return axios.delete(globalApiUrl + '/park-checkin/' + checkinId, {
                    headers: {
                        accept: 'application/x.rvparkreviews.v3+json'
                    },
                    withCredentials: true
                })
            },

            /**
             * Get browser based user location if possible, otherwise ip based location
             * @param silent if true, return cookie-based or ip-based user location (do not request user for browser location)
             * @returns {Promise<unknown>|Promise<{browserLocation: boolean, latitude: *, longitude: *}>}
             */
            getUserLocation(silent = false) {
                //read location from cookies
                const cookieName = window.envObj.USER_LOCATION_COOKIE_NAME;
                let userLocationFromCookie = $cookies.get(cookieName);

                if (!silent || (!browserLocation && !userLocationFromCookie)) {
                    dev.log('requesting location...');

                    const cookieExpiry = window.envObj.USER_LOCATION_COOKIE_EXPIRY;

                    return this.getCurrentPosition().then((location) => {
                        //overwrite initial values
                        userLat = location.coords.latitude;
                        userLon = location.coords.longitude;
                        browserLocation = true;

                        let userBrowserLocation = {
                            'latitude': location.coords.latitude,
                            'longitude': location.coords.longitude,
                            'browserLocation': true
                        };

                        //save to a cookie
                        $cookies.set(cookieName, JSON.stringify(userBrowserLocation), cookieExpiry);

                        return userBrowserLocation;
                    }).catch(error => {
                        //when user has location disabled
                        dev.log(error);

                        //for safari & mozilla, user preference is not saved by default
                        //so if the user has disabled it, set the cookie to disabled which avoids spam requesting them
                        $cookies.set(cookieName, 'disabled', cookieExpiry);

                        //use default ip-based location
                        return {
                            'latitude': userLat,
                            'longitude': userLon,
                            'browserLocation': false
                        }
                    });
                } else {
                    //if userLocation is an object, use it
                    //else use default ip-based location
                    if (userLocationFromCookie && (typeof userLocationFromCookie === 'object')) {
                        userLat = userLocationFromCookie.latitude;
                        userLon = userLocationFromCookie.longitude;
                        browserLocation = userLocationFromCookie.browserLocation;
                    }

                    return new Promise(function (resolve, reject) {
                        resolve({
                            'latitude': userLat,
                            'longitude': userLon,
                            'browserLocation': browserLocation
                        })
                    });
                }
            },
            async waitForAds(maxRetries = 10) {
                let retryCount = 0;
                // Continuously check if the ads have loaded, until maxRetries is reached
                while (retryCount < maxRetries) {
                    // Wait for the DOM to update before checking for the ad
                    await this.$nextTick();
                    let adFound = false;

                    // Check if any of the configured ad is present in the DOM
                    for (const adId of this.adIds) {
                        const ad = document.getElementById(adId);
                        if (ad) {
                            adFound = true;
                            break;
                        }
                    }
                    // If the ad was found, resolve the Promise and return
                    if (adFound) {
                        return;
                    } else {
                        // Wait for 100ms before retrying
                        await new Promise((resolve) => setTimeout(resolve, 100));
                        retryCount++;
                    }
                    dev.log(`Wait for ad to load - max retries reached: ${retryCount} >= ${maxRetries}`);
                }
            },
            hideAds() {
                this.adIds.forEach((adId) => {
                    let ad = document.getElementById(adId);
                    if (ad) {
                        if (ad.style.visibility !== 'hidden') {
                            this.visibleAds.push(adId);
                        }
                        ad.style.visibility = 'hidden';
                    }
                });
            },
            unhideAds() {
                this.visibleAds.forEach((adId) => {
                    let ad = document.getElementById(adId);
                    if (ad) {
                        ad.style.visibility = 'visible';
                    }
                });

                this.visibleAds = [];
            },
            getVueEnv(env) {
                return window.envObj[env] || null;
            }
        }

});

export const app = new Vue({
    el: '#app',
    data: {
        windowWidth: window.innerWidth,
        store: {},
        loading: false,
    },
    store,
    router,

    components: {
        Photos, Theater
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    },
    // created() {
    //     window.addEventListener('resize', () => {
    //         this.windowWidth = window.innerWidth
    //     })
    // },
    // destroyed() {
    //     window.addEventListener('resize', () => {
    //         this.windowWidth = window.innerWidth
    //     })
    // },
    // methods: {
    //     handleResize() {
    //         this.windowWidth = window.innerWidth;
    //         console.log(this.windowWidth);
    //     }
    // },
    computed: {
        toSticky: function () {
            if (this.windowWidth < 645)
                return false;

            return true;
        },
        mobileAds: function () {
            if (this.windowWidth < 768)
                return true;

            return false;
        },
        // mobileFilters: function () {
        //     if (this.windowWidth < 767)
        //         return true;
        //         console.log(this.windowWidth);

        //     return false;
        // },
        showRightRail: function () {
            if (this.windowWidth < 645)
                return false;

            return true;
        }
    }
});
window.app = app;



